var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-upload',{attrs:{"showUploadList":false,"action":"https://admin.dramagostudio.com/admin-api/common/local/file/uploadCos"},on:{"change":_vm.handleChangeEn}},[(_vm.currentSubtitle)?_c('a-button',{attrs:{"type":"primary"}},[_vm._v("更换")]):_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" 上传 ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }